"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const crud_request_1 = __importDefault(require("./crud-request"));
class withUuid extends crud_request_1.default {
    constructor() {
        super(...arguments);
        this.insertByUuid = (data) => __awaiter(this, void 0, void 0, function* () {
            const uuid = yield this.insert(data);
            return { uuid };
        });
        this.deleteByUuid = (uuid) => __awaiter(this, void 0, void 0, function* () {
            const r = yield this.delete({ uuid });
            return r > 0;
        });
        this.updateByUuid = (data) => __awaiter(this, void 0, void 0, function* () {
            if (!data.uuid) {
                throw Error('id undefined');
            }
            return this.update(data, { uuid: data.uuid });
        });
    }
}
exports.default = withUuid;
